// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Table__Wrapper_2Petn","Inner":"Table__Inner_3ruBD"};